module.exports = __webpack_public_path__ + "img/glucose_meter_primary.267c98ef.svg";